import React from "react";
import ReactSelect from "react-select";
import Datetime from "react-datetime";
import Moment from "moment";
import { Option } from "../../../_metronic/helpers/MySelect";
import { statuses } from "./LogJobList";

interface LogJobFilterProps {
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  searchData: () => void;
  removeSearch: () => void;
}

const LogJobFilter: React.FC<LogJobFilterProps> = ({
  state,
  setState,
  searchData,
  removeSearch,
}) => {
  return (
    <div className="collapse" id="jobs-filter" aria-labelledby="jobs-filter">
      <div className="card mt-9">
        <div className="card-body w-100 p-lg-7 p-md-7 p-5">
          <div className="row mt-6">
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">From Date</label>
              <Datetime
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm"
                ref={state.resetFrom}
                closeOnSelect
                value={state.filterFromDate ? Moment(state.filterFromDate).format("YYYY-MM-DD HH:mm") : ""}
                onChange={(e: any) => {
                  const dt = e["_d"];
                  setState({ filterFromDate: dt });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">To Date</label>
              <Datetime
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm"
                ref={state.resetTo}
                closeOnSelect
                value={state.filterToDate ? Moment(state.filterToDate).format("YYYY-MM-DD HH:mm") : ""}
                onChange={(e: any) => {
                  const dt = e["_d"];
                  setState({ filterToDate: dt });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">Job Type</label>
              <ReactSelect
                className="react-select"
                classNamePrefix="my-react-select"
                placeholder=""
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(selected: any) => {
                  const value = selected?.map((e: any) => e.value);
                  setState({ jobTypeSelected: selected, filterJobTypes: value });
                }}
                components={{ Option }}
                value={state.jobTypeSelected}
                options={state.jobTypes.map((value: any) => ({
                  value: value.id,
                  label: value.name,
                }))}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">Location</label>
              <ReactSelect
                className="react-select"
                classNamePrefix="my-react-select"
                placeholder=""
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(selected: any) => {
                  const value = selected?.map((e: any) => e.value);
                  setState({ locationSelected: selected, filterLocation: value });
                }}
                components={{ Option }}
                value={state.locationSelected}
                options={state.locationDB.map((value: any) => ({
                  value: value.id,
                  label: value.name,
                }))}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">Created By</label>
              <ReactSelect
                className="react-select"
                classNamePrefix="my-react-select"
                placeholder=""
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(selected: any) => {
                  const value = selected?.map((e: any) => e.value);
                  setState({ createdBySelected: selected, filterCreatedBy: value });
                }}
                components={{ Option }}
                value={state.createdBySelected}
                options={state.managerDB.map((value: any) => ({
                  value: value.id,
                  label: value.firstName,
                }))}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fw-bold fs-4">Status</label>
              <ReactSelect
                className="react-select"
                classNamePrefix="my-react-select"
                placeholder=""
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(selected: any) => {
                  const value = selected?.map((e: any) => e.value);
                  setState({ statusSelected: selected, filterStatus: value });
                }}
                components={{ Option }}
                value={state.statusSelected}
                options={Array.from(statuses).map((value: any) => ({
                  value: value.id,
                  label: value.name,
                }))}
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
              <label className="form-label fs-4 fw-bold">Machines</label>
              <ReactSelect
                className="react-select"
                classNamePrefix="my-react-select"
                placeholder=""
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={(selected: any) => {
                  const value = selected?.map((e: any) => e.value);
                  setState({ machineSelected: selected, filterMachine: value });
                }}
                components={{ Option }}
                value={state.machineSelected}
                options={state.machineDB.map((value: any) => ({
                  value: value.id,
                  label: `${value.name || value.location?.name || ""} ${value.serialNumber}`,
                }))}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
              <button
                type="submit"
                onClick={searchData}
                className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
              >
                {state.addLoading ? (
                  <span className="indicator-progress" style={{ display: "block" }}>
                    Please Wait..
                    <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                  </span>
                ) : (
                  <span className="indicator-label">ADD FILTER</span>
                )}
              </button>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
              <button
                type="submit"
                onClick={removeSearch}
                className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
              >
                {state.filterLoading ? (
                  <span className="indicator-progress" style={{ display: "block" }}>
                    Please Wait..
                    <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                  </span>
                ) : (
                  <span className="indicator-label">RESET FILTER</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogJobFilter;
